import NotFound from "@/components/common/pages/not-found";
import { Link, Outlet, createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_docs")({
  component: DocsLayoutComponent,
  notFoundComponent: () => <NotFound />,
});

function DocsLayoutComponent() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Header with logo and navigation */}
      <header className="border-b px-6 py-4">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between sm:flex-row">
          <div className="mb-4 sm:mb-0">
            <Link to="/">
              <img
                src="/logo.png"
                alt="Open Farming Technologies Logo"
                className="h-10"
              />
            </Link>
          </div>
          <nav className="flex flex-wrap gap-4 sm:gap-6">
            <Link
              to="/docs/privacy-policy"
              className="font-medium text-gray-700 hover:text-gray-900"
              activeProps={{ className: "text-blue-600 font-semibold" }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/docs/tos"
              className="font-medium text-gray-700 hover:text-gray-900"
              activeProps={{ className: "text-blue-600 font-semibold" }}
            >
              Terms of Service
            </Link>
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 px-4 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
